import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

const Send = memo(({ className, color = '#515151' }) => {
  const icon = useMemo(
    () => (
      <div className={className}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M17.0834 2.91675L11.7616 17.654C11.7257 17.7324 11.668 17.7988 11.5954 17.8454C11.5228 17.892 11.4384 17.9167 11.3522 17.9167C11.266 17.9167 11.1816 17.892 11.109 17.8454C11.0364 17.7988 10.9788 17.7324 10.9428 17.654L8.99411 11.006L2.34608 9.05729C2.2677 9.02136 2.20127 8.96369 2.1547 8.89112C2.10813 8.81856 2.08337 8.73414 2.08337 8.64792C2.08337 8.56169 2.10813 8.47728 2.1547 8.40471C2.20127 8.33214 2.2677 8.27447 2.34608 8.23855L17.0834 2.91675Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    ),
    [className],
  );

  return icon;
});

Send.propTypes = {
  className: PropTypes.string,
};

Send.defaultProps = {
  className: '',
};

export default Send;
